module.exports = __webpack_public_path__ + "static/img/bishnu.3f251014.jpg";